<template>
  <div>
    <!-- 筛选 -->
    <my-search
      timeScreen
      :order="4"
      :selectArr="selectArr"
      :searchParams="searchParams"
      @searchEvent="searchEvent"
    />
    <myTable
      isSelection
      :loading="loading"
      :tableData="tableData"
      :tableHeader="tableHeader"
      :pageParams="pageParams"
      @handleSelectionChange="handleSelectionChange"
    />
    <!-- 分页组件 -->
    <my-pagination :childMsg="pageParams" @callFather="callFather" />
  </div>
</template>

<script>
import mixins from "@/mixins/common";
import { dailyUpdateList, allEnterprise } from "@/network/content/dailyupdate";
export default {
  name: "daily_update",
  mixins: [mixins],
  data() {
    return {
      tableData: [],
      //搜索参数
      searchParams: {
        timeOptions: "",
        selectUnit: "",
      },
      // 所有每日更新企业
      //筛选时下拉框所需参数
      selectArr: [
        {
          name: "selectUnit",
          getData: "value",
          defaultOptions: [],
        },
      ],
      tableHeader: Object.freeze([
        {
          name: "企业简称",
          prop: "shortName",
        },
        {
          name: "是否推送",
          prop: "isPushText",
        },
        {
          name: "更新时间",
          prop: "pushTime",
        },
        {
          name: "操作",
          prop: "operation",
          width: "300",
          operation: [{ name: "文章", clickFun: this.toDetails, show: true }],
        },
      ]),
    };
  },
  async created() {
    await this.getallEnterprise();
  },
  methods: {
    getInitData() {
 
      let timeOptions = this.searchParams.timeOptions; //日期参数
      dailyUpdateList({
        startTime: timeOptions ? timeOptions[0] : "",
        endTime: timeOptions ? timeOptions[1] : "",
        data: {
          unitId: this.searchParams.selectUnit,
        },
        current: this.pageParams.currentPage,
        size: this.pageParams.pageSize,
      })
        .then((res) => {
          let { code, data } = res.data;
          if (code == 200) {

            for (let i in data.records) {
              let arry = data.records[i];
              if (arry.isPush == 0) {
                arry.isPushText = "否";
              } else {
                arry.isPushText = "是";
              }

              this.selectArr[0].defaultOptions.forEach((value, index) => {
                if (value.id == arry.unitId) {
                  arry.shortName = value.shortName;
                }
              });
            }

            this.pageParams.total = data.total;
            this.loading = false;
            this.tableData = data.records;
            
          }
        })
        .catch((err) => {});
    },
    // 每日更新的企业
    getallEnterprise() {
      allEnterprise({ unitId: "" }).then((res) => {
        let { code, data } = res.data;
        if (code == 200) {
          this.selectArr[0].defaultOptions = data.filter((ele) => {
            ele.value = ele.id;
            ele.label = ele.shortName;
            return ele;
          });
        }
      });
    },
    //搜索事件
    searchEvent() {
	  this.pageParams.currentPage = 1;
      this.getInitData();
    },
    // 跳转详情页面
    toDetails(row) {
      this.$router.push({ path: "/dailyDetails", query: { doc: row.doc } });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
